import script from "./ListEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./ListEvents.vue?vue&type=script&setup=true&lang=js"

import "./ListEvents.vue?vue&type=style&index=0&id=41c578cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c578cc"]])

export default __exports__